
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = () => {
    const { user, loading } = useAuth();
    const token = localStorage.getItem('token');
    const location = useLocation();

    if (loading) return null;

    if (!token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check Plan Status
    if (user && Number(user.id) !== 0) {
        const isPending = user.status_assinatura === 'pendente';
        const isBlocked = user.status_assinatura === 'bloqueado' || user.status_assinatura === 'expirado';
        const hasNoPlan = !user.plano_tipo;

        // Check Date Expiration (Client side backup)
        let isDateExpired = false;
        if (user.data_expiracao) {
            const expDate = new Date(user.data_expiracao);
            if (!isNaN(expDate.getTime()) && expDate < new Date()) {
                isDateExpired = true;
            }
        }

        if (isBlocked || isDateExpired || isPending) {
            // Allow access to /assinatura page
            if (location.pathname !== '/assinatura') {
                return <Navigate to="/assinatura" replace />;
            }
        }
    }

    return <Outlet />;
};

export default PrivateRoute;
